import { render } from "./ActiveUsersChart.vue?vue&type=template&id=57fe78ba"
import script from "./ActiveUsersChart.vue?vue&type=script&lang=js"
export * from "./ActiveUsersChart.vue?vue&type=script&lang=js"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__